import { render, staticRenderFns } from "./UpdateProfileRequestView.vue?vue&type=template&id=05f622f2&scoped=true&"
import script from "./UpdateProfileRequestView.vue?vue&type=script&lang=js&"
export * from "./UpdateProfileRequestView.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProfileRequestView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UpdateProfileRequestView.vue?vue&type=style&index=1&id=05f622f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f622f2",
  null
  
)

export default component.exports